import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

/**
 * Shown after payment is confirmed while we provision the customer's account
 * (n8n) and mint the auto-login token. The copy asks the buyer to stay on the
 * screen because this can take a few seconds.
 */
export function PreparingAccessScreen() {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen surface-aurora flex items-center justify-center p-4">
      <div className="card-glass max-w-md w-full p-8 text-center text-[color:var(--text-primary)]">
        <div className="flex justify-center mb-4">
          <Loader2 className="w-8 h-8 animate-spin text-purple-deep" aria-hidden="true" />
        </div>
        <div className="text-2xl font-semibold mb-3">{t("preparingAccess.title")}</div>
        <p className="text-sm text-ink-2 leading-relaxed">{t("preparingAccess.subtitle")}</p>
        <p className="text-xs text-ink-3 mt-3">{t("preparingAccess.doNotClose")}</p>
      </div>
    </main>
  );
}
